module.exports = __webpack_public_path__ + "img/search.5a9cbe65.svg";